module.exports = __webpack_public_path__ + "static/media/rolam.c8b120ab.jpg";